import React from "react";
import { captureMessage } from "@sentry/browser";
import { useHistory, useLocation } from "react-router";
import { buildLink } from "common/routing";
import {
  AiAction,
  useRunSubmissionAiActionMutation,
} from "../../generated/graphql";
import { useStatusToasts } from "../../hooks/useStatusToasts";
import { getCurrentURL } from "../../utils/url";
import SelectionModal from "./SelectionModal";

export type RunAIActionProps = {
  submission: {
    id: string;
    aiActions?: Array<AiAction>;
  };
  prevLocation?: string;
  closeModal: () => void;
};

const RunAIAction = ({ submission, closeModal }: RunAIActionProps) => {
  const { addErrorToast } = useStatusToasts();
  const location = useLocation();
  const history = useHistory();

  const [runAiAction, { loading: runAiActionLoading }] =
    useRunSubmissionAiActionMutation({
      onCompleted: data => {
        const id = data.runSubmissionAIAction;
        history.push(
          buildLink("aIActionRun", {
            id,
          }),
          {
            prevLocation: getCurrentURL(location),
          },
        );
      },
      onError: error => {
        captureMessage(error.message);
        closeModal();
        addErrorToast(
          "There was an issue running the AI action. Please try again. If the problem persists, please email us at support@withforerunner.com",
        );
      },
    });

  const handleSubmit = async (selectedAction: AiAction): Promise<void> => {
    await runAiAction({
      variables: {
        data: {
          submissionId: submission.id,
          aiActionId: selectedAction.id,
        },
      },
    });
  };

  return (
    <SelectionModal
      title="AI Actions"
      subtitle="Choose the AI Action you'd like to run"
      options={submission.aiActions ?? []}
      primaryButtonText="Next"
      closeModal={closeModal}
      onSubmit={handleSubmit}
      loading={runAiActionLoading}
    />
  );
};

export default RunAIAction;
